// extracted by mini-css-extract-plugin
export default {"wrapper":"MediaLink_wrapper__vT6Uk","plainLink":"MediaLink_plainLink__iKSrq"};